module.exports = __webpack_public_path__ + "static/media/drumRoll.24b6f452.mp3";